import { render, staticRenderFns } from "./OccurrenceCustomFields.vue?vue&type=template&id=41ead8d8"
import script from "./OccurrenceCustomFields.vue?vue&type=script&lang=js"
export * from "./OccurrenceCustomFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports